import { NotificationSetting, NotificationHeader, NotificationCategoryTypeEnum } from './type';

export const initialData: NotificationSetting[] = [
  { _id: "1", type: "Ticket assigned to me", isWebEnabled: true, isEmailEnabled: true, category: NotificationCategoryTypeEnum.Tickets, createdAt: "", updatedAt: "" },
  { _id: "2", type: "Ticket status changed", isWebEnabled: true, isEmailEnabled: false, category: NotificationCategoryTypeEnum.Tickets, createdAt: "", updatedAt: "" },
  { _id: "3", type: "Comments on my ticket", isWebEnabled: true, isEmailEnabled: true, category: NotificationCategoryTypeEnum.Tickets, createdAt: "", updatedAt: "" },
  { _id: "4", type: "Mentioned in comment", isWebEnabled: true, isEmailEnabled: true, category: NotificationCategoryTypeEnum.Tickets, createdAt: "", updatedAt: "" },
  { _id: "5", type: "Ticket content updated", isWebEnabled: false, isEmailEnabled: false, category: NotificationCategoryTypeEnum.Tickets, createdAt: "", updatedAt: "" },
  { _id: "6", type: "Subtask created", isWebEnabled: false, isEmailEnabled: true, category: NotificationCategoryTypeEnum.Tickets, createdAt: "", updatedAt: "" },
];

export const headers: NotificationHeader[] = [
  { id: "type", name: "Notification name", sortable: false },
  { id: "isWebEnabled", name: "Web browser", sortable: false },
  { id: "isEmailEnabled", name: "Email", sortable: false },
];
